import { getUsers, createUser, updateUser, deleteUser } from '../models/userModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

// Obtener lista de usuarios paginados
export async function fetchUsers(page, perPage) {
  try {
    const response = await getUsers(page, perPage);
    return {
      users: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching users:", error);
    Swal.fire('Error', 'No se pudieron cargar los usuarios', 'error');
    return null;
  }
}

// Guardar o actualizar un usuario
export async function saveUser(user, currentUserId) {
  try {
    // Handle verification separately
    const { verified, ...userData } = user;
    
    if (currentUserId) {
      // Update user data
      await updateUser(currentUserId, userData);
      
      // If verification is requested, send verification email
      if (verified) {
        await verifyUser(currentUserId);
      }
      
      toasts.add({
        title: 'Éxito',
        description: 'Usuario actualizado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      // For new users, create without verification
      await createUser(userData);
      
      // If verification is requested for new user, send verification email
      if (verified) {
        await verifyUser(userData.id);
      }
      
      toasts.add({
        title: 'Éxito',
        description: 'Usuario creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
  } catch (error) {
    console.error("Error saving user:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el usuario',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

// Eliminar un usuario
export async function removeUser(id) {
  try {
    await deleteUser(id);
    toasts.add({
      title: 'Éxito',
      description: 'Usuario eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting user:", error);
    Swal.fire('Error', 'No se pudo eliminar el usuario', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'users'
export function subscribeToUsers(handleSearch) {
  if (typeof handleSearch !== 'function') {
    console.warn('handleSearch is not a function, real-time updates will not work');
    return;
  }
  
  pb.collection('users').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromUsers() {
  pb.collection('users').unsubscribe('*');
}

// Buscar usuarios por nombre o email con paginación
export async function searchUsers(query, page = 1, perPage = 10) {
  const response = await pb.collection('users').getList(page, perPage, {
    filter: `username ~ "${query}" || email ~ "${query}"`,
  });
  return {
    users: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}

// Cambiar contraseña de usuario
export async function changePassword(userId, newPassword, oldPassword) {
  try {
    await pb.collection('users').update(userId, {
      oldPassword: oldPassword,
      password: newPassword,
      passwordConfirm: newPassword
    });
    
    toasts.add({
      title: 'Éxito',
      description: 'Contraseña actualizada exitosamente',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true,
    });
    return true;
  } catch (error) {
    console.error("Error changing password:", error);
    toasts.add({
      title: 'Error',
      description: 'No se pudo cambiar la contraseña',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
    return false;
  }
}

// Verificar un usuario
export async function verifyUser(userId) {
  try {
    // First get the user's email
    const user = await pb.collection('users').getOne(userId);
    
    // Request verification with the user's email
    await pb.collection('users').requestVerification(user.email);
    
    toasts.add({
      title: 'Éxito',
      description: 'Se ha enviado un correo de verificación al usuario',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true,
    });
    return true;
  } catch (error) {
    console.error("Error verifying user:", error);
    toasts.add({
      title: 'Error',
      description: 'No se pudo enviar el correo de verificación',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
    return false;
  }
}